"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.IndexListingOnly = exports.IndexWithRouter = exports.Index = exports.ConfigContext = void 0;

var _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _reactRouterConfig = require("react-router-config"),
    _useDbStore = require("./useDbStore"),
    _router = require("@reach/router"),
    _Items = require("./Items"),
    _Items2 = _interopRequireDefault(_Items),
    _SingleItemEdit = require("./SingleItemEdit");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var BulkUpload = function BulkUpload() {
  return null;
};

if ("undefined" != typeof window) var _BulkUpload = require("../BulkUpload").default;

var ConfigContext = exports.ConfigContext = (0, _react.createContext)({}),
    Index = exports.Index = _react2.default.memo(function (a) {
  var b = a.routes,
      c = a.url,
      d = a.Config;
  return (0, _useDbStore.useDbStoreInitial)(d), _react2.default.createElement(ConfigContext.Provider, {
    value: d
  }, (0, _reactRouterConfig.renderRoutes)(b));
}),
    IndexWithRouter = exports.IndexWithRouter = _react2.default.memo(function (a) {
  var b = a.Config,
      c = a.OtherRoutes;
  (0, _useDbStore.useDbStoreInitial)(b);

  var d = b.homeUrl(),
      e = function e() {
    return (0, _router.navigate)(-1);
  };

  return _react2.default.createElement(ConfigContext.Provider, {
    value: b
  }, _react2.default.createElement(_router.Router, null, _react2.default.createElement(_Items2.default, {
    path: d,
    navigate: _router.navigate
  }), _react2.default.createElement(_SingleItemEdit.MainForPanel, {
    path: d + "/:pk_val/edit",
    goBack: e
  }), _react2.default.createElement(_SingleItemEdit.MainForPanel, {
    path: d + "/new",
    goBack: e
  }), _react2.default.createElement(BulkUpload, {
    path: d + "/bulk-upload",
    goBack: e
  }), !!c && c));
}),
    IndexListingOnly = exports.IndexListingOnly = _react2.default.memo(function (a) {
  var b = a.Config;
  return (0, _useDbStore.useDbStoreInitial)(b), _react2.default.createElement(ConfigContext.Provider, {
    value: b
  }, _react2.default.createElement(_Items2.default, null));
});